"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _uiTheme = require("@kyruus/ui-theme");
const IconButtonComponent = (0, _uiTheme.withMuiThemeAdapter)(_IconButton.default);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const IconButton_ = props => /*#__PURE__*/_react.default.createElement(IconButtonComponent, props);
IconButton_.displayName = 'IconButton';

// TODO: Move this into its own component. We should add propTypes when we do that.
var _default = exports.default = IconButton_;
IconButton_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconButton"
};